import { render, staticRenderFns } from "./DetalleSeries.vue?vue&type=template&id=7b0af397&"
import script from "./DetalleSeries.vue?vue&type=script&lang=js&"
export * from "./DetalleSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports